/* =========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    name: 'dashboard',
                    component: () => import('./views/Home.vue')
                },
                {
                    path: '/gpu',
                    name: 'gpu',
                    component: () => import('./views/GPU/GPUs.vue')
                },
                {
                    path: '/multicast_nodes',
                    name: 'multicast_nodes',
                    component: () => import('./views/MulticastNode/MulticastNodes.vue')
                },
                {
                    path: '/multicast_node/:id',
                    name: 'multicast_node',
                    component: () => import('./views/MulticastNode/MulticastNode.vue')
                },
                {
                    path: '/workers',
                    name: 'workers',
                    component: () => import('./views/Workers/Workers.vue')
                },
                {
                    path: '/worker/adopt/:id',
                    name: 'worker_adoption',
                    component: () => import('./views/Workers/WorkerAdoption.vue')
                },
                {
                    path: '/worker/adopt/:id/status',
                    name: 'worker_adoption_status',
                    component: () => import('./views/Workers/WorkerAdoptionStatus.vue')
                },
                {
                    path: '/worker/:id',
                    name: 'worker',
                    component: () => import('./views/Workers/Worker.vue')
                },
                {
                    path: '/worker/:id/edit',
                    name: 'worker_edit',
                    component: () => import('./views/Workers/WorkerEdit.vue')
                },
                {
                    path: '/worker/:id/metrics',
                    name: 'worker_metrics',
                    component: () => import('./views/Workers/WorkerMetrics.vue')
                },
                {
                    path: '/worker/:id/add_channel',
                    name: 'worker_add_channel',
                    component: () => import('./views/Workers/WorkerAddChannel.vue')
                },
                {
                    path: '/worker_channels',
                    name: 'worker_channels',
                    component: () => import('./views/WorkerChannel/WorkerChannels.vue')
                },
                {
                    path: '/worker_channel/:id',
                    name: 'worker_channel',
                    component: () => import('./views/WorkerChannel/WorkerChannel.vue')
                },
                {
                    path: '/worker_channel/:id/edit',
                    name: 'worker_channel_edit',
                    component: () => import('./views/WorkerChannel/WorkerChannelEdit.vue')
                },
                {
                    path: '/worker_channel/:id/session/:session_id',
                    name: 'worker_channel_session',
                    component: () => import('./views/WorkerChannel/Session.vue')
                },
                {
                    path: '/timeshift_channels',
                    name: 'timeshift_channels',
                    component: () => import('./views/Timeshift/TimeshiftChannels.vue')
                },
                {
                    path: '/timeshift_channel/:id',
                    name: 'timeshift_channel',
                    component: () => import('./views/Timeshift/TimeshiftChannel.vue')
                },
                {
                    path: '/gpu/:id',
                    name: 'gpu_data',
                    component: () => import('./views/GPU/GPU.vue')
                },
                {
                    path: '/providers',
                    name: 'providers',
                    component: () => import('./views/Providers/Providers.vue')
                },
                {
                    path: '/provider/:id',
                    name: 'provider',
                    component: () => import('./views/Providers/Provider.vue')
                },
                {
                    path: '/sources',
                    name: 'sources',
                    component: () => import('./views/Sources/Sources.vue')
                },
                {
                    path: '/source/:id',
                    name: 'source',
                    component: () => import('./views/Sources/Source.vue')
                },
                {
                    path: '/channels',
                    name: 'channels',
                    component: () => import('./views/Channels/Channels.vue')
                },
                {
                    path: '/channel/:id',
                    name: 'channel',
                    component: () => import('./views/Channels/Channel.vue')
                },
                {
                    path: '/templates/input',
                    name: 'input_templates',
                    component: () => import('./views/Templates/Templates.vue'),
                    props: { templateList: 0 }
                },
                {
                    path: '/templates/work',
                    name: 'work_templates',
                    component: () => import('./views/Templates/Templates.vue'),
                    props: { templateList: 1 }
                },
                {
                    path: '/templates/output',
                    name: 'output_templates',
                    component: () => import('./views/Templates/Templates.vue'),
                    props: { templateList: 2 }
                },
                {
                    path: '/templates/shaka',
                    name: 'shaka_templates',
                    component: () => import('./views/Templates/Templates.vue'),
                    props: { templateList: 3 }
                },
                {
                    path: '/template/:id',
                    name: 'template',
                    component: () => import('./views/Templates/Template.vue')
                },
                {
                    path: '/locations',
                    name: 'locations',
                    component: () => import('./views/Locations/Locations.vue')
                },
                {
                    path: '/location/:id',
                    name: 'location',
                    component: () => import('./views/Locations/Location.vue')
                },
                {
                    path: '/movies',
                    name: 'movies',
                    component: () => import('./views/VODMovies/Movies.vue')
                },
                {
                    path: '/movie/:id',
                    name: 'movie',
                    component: () => import('./views/VODMovies/Movie.vue')
                },
                {
                    path: '/packages',
                    name: 'packages',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Package/Packages.vue')
                },
                {
                    path: '/package/:id',
                    name: 'package',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Package/Package.vue')
                },
                {
                    path: '/resellers',
                    name: 'resellers',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Reseller/Resellers.vue')
                },
                {
                    path: '/reseller/:id',
                    name: 'reseller',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Reseller/Reseller.vue')
                },
                {
                    path: '/subscribers',
                    name: 'subscribers',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Subscriber/Subscribers.vue')
                },
                {
                    path: '/subscriber/:id',
                    name: 'subscriber',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Subscriber/Subscriber.vue')
                },
                {
                    path: '/clients',
                    name: 'clients',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Clients/Clients.vue')
                },
                {
                    path: '/client/:id',
                    name: 'client',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/Clients/Client.vue')
                },
                {
                    path: '/client_connections',
                    name: 'client_connections',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/ClientConnections/ClientConnections.vue')
                },
                {
                    path: '/watch_statistics',
                    name: 'watch_statistics',
                    meta: {
                        required_capability: 2
                    },
                    component: () => import('./views/WatchStatistics/WatchStatistics.vue')
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import('./views/Users/Users.vue')
                },
                {
                    path: '/api_keys',
                    name: 'api_keys',
                    component: () => import('./views/APIKey/APIKeys.vue')
                },
                {
                    path: '/roles',
                    name: 'roles',
                    component: () => import('./views/Roles/Roles.vue')
                },
                {
                    path: '/epg_providers',
                    name: 'epg_providers',
                    component: () => import('./views/EPG/EPGProviders')
                },
                {
                    path: '/epg_provider/:id',
                    name: 'epg_provider',
                    component: () => import('./views/EPG/EPGProvider')
                },
                {
                    path: '/stb_config',
                    name: 'stb_config',
                    component: () => import('./views/STBConfig/STBConfig')
                },
                {
                    path: '/system_config',
                    name: 'system_config',
                    component: () => import('./views/Settings/SystemConfig')
                },
                {
                    path: '/license',
                    name: 'license',
                    component: () => import('./views/License/License')
                }

            ]
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.beforeEach((to, from, next) => {
    if (!store.getters.loggedIn && to.path !== '/login') {
        return next('/login')
    }

    if (to.meta.permission && store.getters.userData) {
        if (store.getters.permissions.includes(to.meta.permission)) {
            return next()
        } else {
            return next(false)
        }
    }

    if (to.meta.required_capability) {
        if (store.state.capabilities.includes(to.meta.required_capability)) {
            return next()
        } else {
            if (from.name === null) {
                return next('/')
            }
            return next(false)
        }
    }

    next()
})

export default router
